import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  private baseUrl = environment.projectapiUrl + "/genai-mic/project/v1/system";
  private baseUrlAuth = environment.authApiUrl + 'genai-mic/auth/v3/system';
  constructor(private http: HttpClient) { }

  getProjectsPaged(page: number, size: number) {
    const params = new HttpParams().set("page", page).set("size", size);
    return this.http.get(this.baseUrl + "/list/projects", { params });
  }

  getProjectById(id: string) {
    return this.http.get(this.baseUrl + "/get/project/" + id);
  }

  createProject(body: any) {
    return this.http.post(this.baseUrl + "/projects", body);
  }

  updateProject(body: any) {
    return this.http.put(this.baseUrl + "/projects", body);
  }



  disableProject(id: string) {
    return this.http.delete(`${this.baseUrl}/disable/${id}`);
  }

  deleteProject(projectId: string) {
    const body = {
      projectId: projectId
    };

    return this.http.post(
      `${this.baseUrl}/project/delete`,
      body
    );
  }


  getAllMicroservices() {
    return this.http.get<any[]>(`${this.baseUrlAuth}/list/microservices`);
  }

  addMicroservice(projectId: string, serviceName: string) {
    return this.http.post(this.baseUrl + '/projects/microservice/add', {
      projectId,
      serviceName
    });
  }

  removeMicroservice(projectId: string, serviceName: string) {
    return this.http.post(this.baseUrl + '/projects/microservice/remove', {
      projectId,
      serviceName
    });
  }

}
